<ng-container rtBlock="sc-home-type-card">
    <a rtElem="link" [routerLink]="link()" [attr.aria-label]="caption()"></a>
    <div rtElem="head">
        <span rtElem="num">{{ num() }}</span>
        <span rtElem="specs">{{ specs() }}</span>
    </div>
    <div rtElem="sketch">
        <span rtElem="proj">{{ proj() }}</span>
        <ng-content select="svg" />
        <span rtElem="axis">{{ axis() }}</span>
    </div>
    <div rtElem="meta">
        <ng-content select="[meta-rows]" />
    </div>
    <h3 rtElem="caption">{{ caption() }}</h3>
    <div rtElem="desc">{{ desc() }}</div>
    <div rtElem="arrow" aria-hidden="true">→</div>
</ng-container>
